export const DEFAULT_LOGO = "https://s3.ap-southeast-1.amazonaws.com/s3.onefence.co/mol-logo.png"
